<template>
    <div>
        <template v-if="owner">
            <div class="d-flex align-items-center mb-4">
                <h2>Jobtype</h2>
                <v-spacer></v-spacer>
                <template v-if="value && owner">
                    <eod-delete-dialog v-model="isDeleteDialogVisible" :item="value"
                        @delete="deleteConfiguration">
                    </eod-delete-dialog>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="isDeleteDialogVisible = true" class="mr-4" :loading="sendingConfiguration"
                                color="error" fab x-small depressed v-bind="attrs" v-on="on">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </template>
                        Flow en configuratie verwijderen
                    </v-tooltip>
                </template>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="align-self-center" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="exportTemplateAction">
                            <v-list-item-icon><v-icon>mdi-export</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Exporteren</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="showImportDialog = true">
                            <v-list-item-icon><v-icon>mdi-import</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Importeren</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <eod-dialog v-if="showImportDialog" v-model="showImportDialog" width="600" title="Importeren"
                    icon="mdi-import" iconColor="secondary">

                    <v-file-input hide-details v-model="importFile" truncate-length="40"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        label="Bestand" outlined dense></v-file-input>

                    <template v-slot:actions>
                        <v-btn text rounded @click="(showImportDialog = false)">Annuleren</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :loading="importLoading" depressed :disabled="(importFile == null)" rounded
                            color="secondary" @click="importTemplateAction">
                            <v-icon left>mdi-import</v-icon>
                            Importeren
                        </v-btn>
                    </template>
                </eod-dialog>
            </div>
            <eod-object-autocomplete :defaultFilter="{
                where: [
                    {
                        'column': 'isConnectable',
                        'operator': '=',
                        'value': '1'
                    }
                ]
            }" label="Jobtype" endpoint="jobTypes" :value="jobType" return-object
                @change="selectTemplate"></eod-object-autocomplete>

            <template v-if="value">
                <template v-if="jobTypeTemplate && jobTypeTemplate.variables.length > 0">
                    <v-divider class="mb-4 mt-4"></v-divider>
                    <h2>Variabelen</h2>
                    <table class="w-100">
                        <tr v-for="variable in jobTypeTemplate.variables" :key="variable.value">
                            <td width="300">
                                {{ variable.text }}
                            </td>
                            <td>
                                <eod-objects-treeview-input clearable @input="val => setVariableValue(variable.value, val)"
                                    :value="getVariableValue(variable.value) ? getVariableValue(variable.value).id : null"
                                    :selectable="['DEVICE']" :rules="[getVariableValue(variable.value)?$validator.unique(getVariableValue(variable.value).id, Object.values(value.content.variables), variable.text):null, val => $validator.required(val, 'Variabele ' + variable.text)]">
                                    <template v-slot:append-item>
                                        <v-divider class="mb-2"></v-divider>
                                        <v-list-item @click.stop="showCreateAssetDialog(variable)">
                                            <v-list-item-icon>
                                                <v-icon>mdi-plus</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Nieuwe asset aanmaken</v-list-item-title>
                                                <v-list-item-subtitle>Maak een nieuwe asset aan</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </eod-objects-treeview-input>
                            </td>
                        </tr>
                    </table>
                    <eod-dialog v-if="isCreateAssetDialogVisible" v-model="isCreateAssetDialogVisible" width="1200"
                        :loading="isCreateAssetDialogLoading" @okAction="saveNewAsset" okText="Aanmaken"
                        :hide-ok="isCreateAssetDialogSaving">
                        <eod-product-detail hide-save ref="assetDetailRef" :value="createAssetValue"
                            @loading="val => { isCreateAssetDialogLoading = val; }"
                            @saving="val => { isCreateAssetDialogSaving = val }"></eod-product-detail>
                    </eod-dialog>
                </template>
                <v-alert type="info" text v-else-if="jobTypeTemplate">Geen variabelen gevonden voor dit
                    jobtype</v-alert>
                <v-alert type="info" text v-else>Selecteer een jobtype</v-alert>

                <v-divider class="mb-4 mt-4"></v-divider>
                <h2 class="mb-4">Meetwaardes</h2>
                <v-expansion-panels>
                    <v-expansion-panel v-for="cell in templateMeasurementTypeCells" :key="cell.id">
                        <v-expansion-panel-header v-if="resolvedMeasurementTypes[cell.settings.measurementTypeId]">
                            {{ resolvedMeasurementTypes[cell.settings.measurementTypeId].name }}<strong class="ml-2"
                                v-if="getMetricValue(cell, 'name')">({{ getMetricValue(cell, 'name') }})</strong>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <template v-if="cell.settings.product && cell.settings.product.variable">
                                <table class="w-100">
                                    <tr>
                                        <td width="300">
                                            <div class="subtitle-2">Variabele</div>
                                            {{ getVariableNameById(cell.settings.product.variable) }}
                                        </td>
                                        <td>
                                            <div class="subtitle-2">Product</div><span
                                                v-if="value && resolvedProducts[value.content.variables[cell.settings.product.variable]]">{{
                                                    resolvedProducts[value.content.variables[cell.settings.product.variable]].name
                                                }}</span>
                                        </td>
                                    </tr>
                                </table>
                            </template>
                            <template v-else-if="cell.settings.product && cell.settings.product.id">
                                <table class="w-100">
                                    <tr>
                                        <td width="100"><span class="subtitle-2">Product</span></td>
                                        <td><span v-if="resolvedProducts[cell.settings.product.id]">{{
                                            resolvedProducts[cell.settings.product.id].name
                                                }}</span>
                                        </td>
                                    </tr>
                                </table>
                            </template>
                            <div class="mt-4">
                                <v-row>
                                    <v-col>
                                        <v-text-field outlined dense hide-details label="HardwareId"
                                            :value="getMetricValue(cell, 'name')"
                                            @input="val => setMetricValue(cell.id, 'name', val)"></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-autocomplete outlined dense hide-details label="dataType"
                                            :items="MeasurementType.Metric_DataTypes"
                                            :value="getMetricValue(cell, 'dataType')"
                                            @input="val => setMetricValue(cell.id, 'dataType', val)"></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col><v-text-field type="number" step="0.1" outlined dense hide-details
                                            label="Factor" :value="getMetricPropertyValue(cell, 'factor')"
                                            @input="val => setMetricPropertyValue(cell.id, 'factor', val)"></v-text-field></v-col>
                                    <v-col><v-text-field type="number" step="0.1" outlined dense hide-details
                                            label="Offset" :value="getMetricPropertyValue(cell, 'offset')"
                                            @input="val => setMetricPropertyValue(cell.id, 'offset', val)"></v-text-field></v-col>
                                    <v-col><v-text-field type="number" step="1" outlined dense hide-details
                                            label="Interval" :value="getMetricPropertyValue(cell, 'interval')"
                                            @input="val => setMetricPropertyValue(cell.id, 'interval', val)"></v-text-field></v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <eod-autocomplete label="Methode"
                                            :items="MeasurementType.Metric_Methods"
                                            :value="getMetricPropertyValue(cell, 'method')"
                                            @input="val => setMetricPropertyValue(cell.id, 'method', val)">
                                        <template v-slot:item="{item}">
                                            <v-list-item-content>
                                                    <v-list-item-title v-text="item.text"></v-list-item-title>
                                                    <v-list-item-subtitle v-text="item.info"></v-list-item-subtitle>
                                                </v-list-item-content>
                                        </template>
                                        </eod-autocomplete>
                                    </v-col>
                                    <v-col v-if="getMetricPropertyValue(cell, 'method') == 'MONITORED'">
                                        <eod-text-field step="0.1" type="number" label="Absolute afwijking" :value="getMetricPropertyValue(cell, 'deviation')" @input="val => setMetricPropertyValue(cell.id, 'deviation', val)">
                                            <template v-slot:append>
                                                <div class="px-2">{{resolvedMeasurementTypes[cell.settings.measurementTypeId]?.unit?.name}}</div>
                                            </template>
                                        </eod-text-field>
                                    </v-col>
                                </v-row>

                            </div>

                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </template>
        </template>
        <v-alert v-else type="info" text>U dient eerst de connector te bewaren voor u de configuratie kunt
            instellen!</v-alert>
    </div>
</template>
<style lang="scss" scoped>
.v-expansion-panel-header {
    transition: .2s all;

    &.v-expansion-panel-header--active {
        background-color: var(--v-primary-lighten5);
        min-height: 50px;
        padding: 10px 24px;
        margin-bottom: 10px;
    }
}
</style>
<script>
import eodObjectsTreeviewInput from './eod-objects-treeview-input.vue';
import eodProductDetail from './eod-product-detail.vue';
import eodDeleteDialog from './eod-delete-dialog';
import eodDialog from './eod-dialog';
import eodObjectAutocomplete from './eod-object-autocomplete.vue';

export default {
    name: 'eod-job-types-config',
    components: {
        eodObjectsTreeviewInput,
        eodDeleteDialog,
        eodProductDetail,
        eodDialog,
        eodObjectAutocomplete
    },
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        owner: Object,
        jobTypeId: String
    },
    data: () => ({
        MeasurementType: require('./../models/measurementType').default,
        isDeleteDialogVisible: false,
        jobType: null,
        jobTypeTemplates: {},
        jobTypeTemplate: null,
        resolvedMeasurementTypes: {},
        resolvedProducts: {},
        templateMeasurementTypeCells: [],
        sendingConfiguration: false,
        hasTemplateFilter: true,
        isCreateAssetDialogSaving: false,
        importFile: null,
        showImportDialog: false,
        importLoading: false,
        isCreateAssetDialogLoading: false,
        isCreateAssetDialogVisible: false,
        createAssetValue: null,
        activeVariable: null,
    }),
    mounted() {
        if (this.jobTypeId) {
            this.$eod.getById('jobType', this.jobTypeId, ['id', 'name', 'defaultProject{id}', 'defaultService{id}'])
                .then(response => {
                    this.jobType = response.data.data.jobType;
                    this.selectTemplate(this.jobType);
                });
        } else if (this.value) {
            this.selectTemplate({ id: this.value.content.jobTypeId });
        }
    },
    methods: {
        showCreateAssetDialog(variable) {
            this.activeVariable = variable;
            this.createAssetValue = {
                statusCode: {},
                class: 'DEVICE'
            };

            const jobtype = this.jobType;

            let name = '';

            if (this.owner && this.owner.name) {
                name += this.owner.name;
            }

            if (jobtype.defaultProject && jobtype.defaultProject.id) {
                this.createAssetValue.treeParentId = jobtype.defaultProject.id;
            }

            if (jobtype.defaultService && jobtype.defaultService.id) {
                this.createAssetValue.serviceId = jobtype.defaultService.id;
            }

            if (variable.productType && variable.productType.id) {
                this.createAssetValue.productType = variable.productType;

                if (name != '') {
                    name += ' - ';
                }

                name += variable.productType.name;
            }

            if (variable && variable.text) {
                this.createAssetValue.description = variable.text;
            }

            this.createAssetValue.name = name;

            this.isCreateAssetDialogVisible = true;
        },
        exportTemplateAction() {
            this.$eod.exportJobTypeConfig(this.value).then(response => {
                if (response.data.success) {
                    window.location.href = response.data.path;
                }
            });
        },
        saveNewAsset() {
            if (this.$refs.assetDetailRef) {
                this.$refs.assetDetailRef.saveItem().then(productId => {
                    if (productId) {
                        this.bindAssetToVariable(productId);
                    }
                });
            }
        },
        importTemplateAction() {
            this.importLoading = true;
            this.$eod.importJobTypeConfig(this.importFile).then(response => {
                if (response.data.success) {
                    this.convertImportToTemplate(response.data.cells);
                }
            }).finally(() => {
                this.importFile = null;
                this.importLoading = false;
            })
        },
        bindAssetToVariable(productId) {
            this.setVariableValue(this.activeVariable.value, productId);
            this.isCreateAssetDialogVisible = false;
            this.isCreateAssetDialogSaving = false;
            this.createAssetValue = null;
        },
        convertImportToTemplate(cells) {
            const activeTemplate = this.value;

            const propertyFields = ['deviceId', 'factor', 'interval', 'method', 'offset'];

            for (let i = 0; i < cells.length; i++) {
                const cell = cells[i];
                for (let j = 0; j < activeTemplate.content.metrics.length; j++) {
                    const metric = activeTemplate.content.metrics[j];
                    if (metric.properties.cellId.value == cell.cellId) {
                        activeTemplate.content.metrics[j].dataType = cell.dataType || null;
                        activeTemplate.content.metrics[j].name = cell.hardwareId || null;
                        for (let fieldIndex = 0; fieldIndex < propertyFields.length; fieldIndex++) {
                            const fieldName = propertyFields[fieldIndex];
                            if (activeTemplate.content.metrics[j].properties[fieldName]) {
                                activeTemplate.content.metrics[j].properties[fieldName].value = cell[fieldName] || null;
                            }
                        }
                        break;
                    }
                }
            }

            this.$emit('input', activeTemplate);

            this.showImportDialog = false;
        },
        async deleteConfiguration() {
            this.sendingConfiguration = true;

            if(this.value.id){
                await this.$eod.delete('Template', this.value.id);
            }

            this.$emit('input', null);

            this.$nextTick(() => {
                this.sendingConfiguration = false;
                this.$forceUpdate();
            });

        },
        getMetricPropertyValue(cell, propertyName) {
            if (this.value) {
                for (let i = 0; i < this.value.content.metrics.length; i++) {
                    const metric = this.value.content.metrics[i];
                    if (metric.properties.cellId.value == cell.id) {
                        if (metric.properties[propertyName]) {
                            return metric.properties[propertyName].value;
                        }

                    }
                }
            } else {
                // No template available, use default values of measurementType
                if (this.resolvedMeasurementTypes[cell.settings.measurementTypeId]) {
                    const measurementType = this.resolvedMeasurementTypes[cell.settings.measurementTypeId];
                    if (measurementType.metricConfig && measurementType.metricConfig[propertyName]) {
                        return measurementType.metricConfig[propertyName];
                    }
                }
            }

            return null;
        },
        setMetricPropertyValue(cellId, propertyName, val) {
            const template = this.value;
            
                if (template) {
                    for (let i = 0; i < template.content.metrics.length; i++) {
                        const metric = template.content.metrics[i];
                        if (metric.properties.cellId.value == cellId) {
                            if (!template.content.metrics[i].properties[propertyName]) {
                                template.content.metrics[i].properties[propertyName] = {
                                    type: 'String',
                                    value: null
                                };
                            }

                            template.content.metrics[i].properties[propertyName].value = val;
                            break;
                        }
                    }
                }

                this.$emit('input', template);
        },
        getMetricValue(cell, propertyName) {
            if (this.value?.content?.metrics) {
                for (let i = 0; i < this.value.content.metrics.length; i++) {
                    const metric = this.value.content.metrics[i];
                    if (metric.properties.cellId.value == cell.id) {
                        return metric[propertyName];
                    }
                }
            } else {
                // No template available, use default values of measurementType
                if (propertyName == 'name') {
                    propertyName = 'hardwareId';
                }

                if (this.resolvedMeasurementTypes[cell.settings.measurementTypeId]) {
                    const measurementType = this.resolvedMeasurementTypes[cell.settings.measurementTypeId];
                    if (measurementType.metricConfig && measurementType.metricConfig[propertyName]) {
                        return measurementType.metricConfig[propertyName];
                    }
                }
            }

            return null;
        },
        setMetricValue(cellId, propertyName, val) {
            const template = this.value;
                if (template) {
                    for (let i = 0; i < template.content.metrics.length; i++) {
                        const metric = template.content.metrics[i];
                        if (metric.properties.cellId.value == cellId) {
                            template.content.metrics[i][propertyName] = val;
                            break;
                        }
                    }
                }

                this.$emit('input', template);
        },
        getVariableNameById(variableId) {
            if (this.jobTypeTemplate && this.jobTypeTemplate.variables) {
                for (let i = 0; i < this.jobTypeTemplate.variables.length; i++) {
                    const variable = this.jobTypeTemplate.variables[i];
                    if (variable.value == variableId) {
                        return variable.text;
                    }
                }
            }

            return null;
        },
        resolveProducts(template) {
            return new Promise(resolve => {
                const productIds = [];
                if (this.value && this.value.content) {
                    for (const variableId in this.value.content.variables) {
                        const productId = this.value.content.variables[variableId];
                        if (productId) {
                            productIds.push(productId);
                        }
                    }
                }

                for (let i = 0; i < template.variables.length; i++) {
                    const variable = template.variables[i];
                    if(variable.product?.id){
                        productIds.push(variable.product.id);
                    }
                }

                for (let i = 0; i < template.pages.length; i++) {
                    const page = template.pages[i];
                    for (let j = 0; j < page.cells.length; j++) {
                        const cell = page.cells[j];
                        if (cell.settings && cell.settings.product && cell.settings.product.id && !productIds.includes(cell.settings.product.id) && !this.resolvedProducts[cell.settings.product.id]) {
                            productIds.push(cell.settings.product.id);
                        }
                    }
                }

                if (productIds.length > 0) {
                    this.$eod.get('resolveProducts', ['id', 'name'], {
                        whereIn: {
                            column: 'id',
                            array: productIds
                        }
                    }).then(response => {
                        if (response.data.data && response.data.data.resolveProducts && response.data.data.resolveProducts.edges) {
                            const resolveProducts = response.data.data.resolveProducts.edges;
                            for (let i = 0; i < resolveProducts.length; i++) {
                                const product = resolveProducts[i];
                                this.resolvedProducts[product.id] = product;
                            }

                            this.$forceUpdate();
                            resolve();
                        }
                    });
                } else {
                    resolve();
                }
            });
        },
        async getTemplateMeasurementTypeCells() {
            return new Promise(async resolve => {
                if (this.jobTypeTemplate) {
                    const measurementTypeIds = [];

                    const templateMeasurementTypeCells = [];

                    for (let i = 0; i < this.jobTypeTemplate.pages.length; i++) {
                        const page = this.jobTypeTemplate.pages[i];
                        for (let j = 0; j < page.cells.length; j++) {
                            const cell = page.cells[j];
                            if (cell.settings && cell.settings.measurementTypeId) {
                                templateMeasurementTypeCells.push(cell);
                                if (!this.resolvedMeasurementTypes[cell.settings.measurementTypeId]) {
                                    measurementTypeIds.push(cell.settings.measurementTypeId);
                                }
                            }
                        }
                    }

                    if (measurementTypeIds.length > 0) {
                        this.$eod.get('measurementTypes', ['id', 'name', 'unit{name}', 'metricConfig{dataType factor hardwareId interval method offset}'], {
                            whereIn: {
                                column: 'id',
                                array: measurementTypeIds
                            }
                        }).then(response => {
                            if (response.data.data && response.data.data.measurementTypes && response.data.data.measurementTypes.edges) {
                                const measurementTypes = response.data.data.measurementTypes.edges;
                                for (let i = 0; i < measurementTypes.length; i++) {
                                    const measurementType = measurementTypes[i];
                                    this.resolvedMeasurementTypes[measurementType.id] = measurementType;
                                }

                                resolve(templateMeasurementTypeCells);
                            } else {
                                resolve(templateMeasurementTypeCells);
                            }
                        }).catch(err => {
                            resolve(templateMeasurementTypeCells);
                        });
                    } else {
                        resolve(templateMeasurementTypeCells);
                    }
                } else {
                    resolve([]);
                }
            });

        },
        async generateMetrics(template) {
            this.templateMeasurementTypeCells = await this.getTemplateMeasurementTypeCells();

            const cellIds = [];
            for (let i = 0; i < this.templateMeasurementTypeCells.length; i++) {
                const cell = this.templateMeasurementTypeCells[i];
                cellIds.push(cell.id);

                let metricIndex = null;
                for (let j = 0; j < template.content.metrics.length; j++) {
                    const metric = template.content.metrics[j];
                    if (metric.properties.cellId.value == cell.id) {
                        metricIndex = j;
                        break;
                    }
                }

                if (metricIndex == null) {
                    let metricData = {
                        name: "",
                        dataType: "Float",
                        properties: {
                            cellId: {
                                type: "String",
                                value: cell.id
                            },
                            factor: {
                                type: 'Float',
                                value: null
                            },
                            offset: {
                                type: 'Float',
                                value: null
                            },
                            interval: {
                                type: 'Float',
                                value: null
                            },
                            method: {
                                type: 'String',
                                value: null
                            },
                            deviation: {
                                type: 'Float',
                                value: null
                            },

                        }
                    };

                    if (this.resolvedMeasurementTypes[cell.settings.measurementTypeId]) {
                        const measurementType = this.resolvedMeasurementTypes[cell.settings.measurementTypeId];
                        if (measurementType.metricConfig) {
                            metricData.name = measurementType.metricConfig.hardwareId;
                            metricData.dataType = measurementType.metricConfig.dataType;
                            metricData.properties.factor.value = measurementType.metricConfig.factor;
                            metricData.properties.offset.value = measurementType.metricConfig.offset;
                            metricData.properties.interval.value = measurementType.metricConfig.interval;
                            metricData.properties.method.value = measurementType.metricConfig.method;
                        }
                    }

                    if(cell.settings.hardwareId){
                        metricData.name = cell.settings.hardwareId;
                    }

                    template.content.metrics.push(metricData);
                    metricIndex = template.content.metrics.length - 1;
                }

                template.content.metrics[metricIndex].properties.measurementTypeId = {
                    type: "String",
                    value: cell.settings.measurementTypeId
                }

                if (cell.settings.product && cell.settings.product.id) {
                    template.content.metrics[metricIndex].properties.deviceId = {
                        type: "String",
                        value: cell.settings.product.id
                    }
                } else if (cell.settings.product && cell.settings.product.variable && template.content.variables[cell.settings.product.variable]) {
                    template.content.metrics[metricIndex].properties.deviceId = {
                        type: "String",
                        value: template.content.variables[cell.settings.product.variable]
                    }
                }
            }

            const metrics = Object.assign([], template.content.metrics);

            for (let i = 0; i < metrics.length; i++) {
                const metric = metrics[i];
                if (!cellIds.includes(metric.properties.cellId.value)) {
                    template.content.metrics.splice(i, 1);
                }
            }

            return template;

        },
        generateNewTemplate(){
            const newTemplate = {
                type: 'JOB_TYPE_CONFIG',
                jobTypes: [{id:this.jobType.id}],
                object: 'USER',
                content: {
                    jobTypeId: this.jobType.id,
                    ownerId: this.owner.id,
                    variables: {},
                    metrics: []
                },
                isActive: true,
                organizationId: this.$eod.getRealm(),
                name: 'Configuratie ' + this.owner.name,
            };

            if(this.jobTypeTemplate && this.jobTypeTemplate.variables){
                for (let i = 0; i < this.jobTypeTemplate.variables.length; i++) {
                    const variable = this.jobTypeTemplate.variables[i];
                    newTemplate.content.variables[variable.value] = variable.product?.id || null;
                }
            }

            return newTemplate;
        },
        async setVariableValue(variableId, val) {
            let template = this.value;
            if (!template.content.variables) {
                template.content.variables = {};
            }

            template.content.variables[variableId] = val;
            template = await this.generateMetrics(template);

            this.$emit('input', template);

            this.$nextTick(() => {
                this.resolveProducts(this.jobTypeTemplate);
            });
        },
        getVariableValue(variableId) {
            const template = this.value;
            if (!template.content || !template.content.variables) {
                return null;
            }

            if (template.content.variables[variableId]) {

                const productId = template.content.variables[variableId];
                if (this.resolvedProducts[productId]) {
                    return this.resolvedProducts[productId];
                }

                return { id: productId };
            }

            return null;
        },
        async selectTemplate(jobType) {
            this.jobType = jobType;

            await this.loadTemplateVariables(jobType.id);

            let template = null;
            if(this.value && this.value.content?.jobTypeId == jobType.id){
                template = await this.generateMetrics(this.value);
            } else {
                template = await this.generateMetrics(this.generateNewTemplate());
            }

            // Change updatedAt so check for when engine flow get updated is changed
            template.updatedAt = this.$moment();
            this.$emit('input', template);

            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        async loadTemplateVariables(jobTypeId) {
            // Get jobtype templates
            this.jobTypeTemplate = null;

            return this.getJobTypeTemplate(jobTypeId).then(template => {
                if (!template) {
                    return null;
                }

                if (!template.content.variables) {
                    return null;
                }

                return template.content;
            }).then(async jobTypeTemplate => {

                if (jobTypeTemplate) {
                    await this.resolveProducts(jobTypeTemplate);

                    this.jobTypeTemplate = jobTypeTemplate;
                }
            });
        },
        getJobTypeTemplate(jobTypeId) {
            return new Promise((resolve) => {
                // Temp get template via jobType
                if (this.jobTypeTemplates[jobTypeId]) {
                    resolve(this.jobTypeTemplates[jobTypeId]);
                }

                this.$eod.get('templates', ['id', 'name', 'content', 'type'], {
                    whereInRelated: [{
                        column: 'jobTypeId',
                        relation: 'jobTypes_templates',
                        array: [jobTypeId]
                    }],
                    where: [
                        {
                            column: 'type',
                            operator: '=',
                            value: 'FORM'
                        }
                    ]
                }).then(response => {
                    if (response.data.data) {
                        const templates = response.data.data.templates.edges;
                        if (templates[0]) {
                            this.jobTypeTemplates[jobTypeId] = templates[0];
                            resolve(templates[0]);
                        }
                    }

                    resolve(null);
                });
            });
        },
    }
}
</script>